import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackBrandContextSelected.meta';

export type ShareLinkType = 'board' | 'collection';

export type UseTrackBrandContextSelectedParams = {
  brand_context_name: string;
  share_link_type: ShareLinkType;
};

export const useTrackBrandContextSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackBrandContextSelected = useCallback(
    (params: UseTrackBrandContextSelectedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackBrandContextSelected };
};
